import React from 'react';
import { bool, shape, string } from 'prop-types';

const FieldGroupColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75H10.5C10.9142 6.75 11.25 7.08579 11.25 7.5V10.5C11.25 10.9142 10.9142 11.25 10.5 11.25H7.5C7.08579 11.25 6.75 10.9142 6.75 10.5V7.5Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M3.75 2.25H5.25V3.75L12.75 3.75V2.25H14.25V3.75L15.75 3.75V5.25H14.25V12.75H15.75V14.25H14.25V15.75H12.75V14.25L5.25 14.25V15.75H3.75V14.25H2.25V12.75H3.75V5.25H2.25V3.75L3.75 3.75V2.25ZM5.25 12.75V5.25L12.75 5.25V12.75L5.25 12.75Z" fill="currentColor" />
  </svg>
);

FieldGroupColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default FieldGroupColor;
